import * as React from "react";
import {
  Create,
  SimpleForm,
  SelectInput,
  ReferenceInput,
  required,
  TextInput,
  useRedirect,
  useNotify,
  useRefresh,
  Toolbar,
  SaveButton,
  minValue,
  maxValue,
  AutocompleteInput,
} from "react-admin";
import { intRegex } from "../../shared/components/index.js";
import { MERCHANT_PAYMENT_GATEWAY_STATUSES } from "@local/constants/index.js";

const SaveTruncToolbar = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onError = ({ message }) => {
    if (message.includes("privateKey.pem")) {
      return (
        notify("resources.notifications.errors.Forbidden", {
          type: "error",
        }),
        refresh()
      );
    }

    if (message.includes("undefined or null")) {
      return (
        notify("resources.notifications.errors.Forbidden", {
          type: "error",
        }),
        refresh()
      );
    }

    return (
      notify(`resources.notifications.errors.${message}`, {
        type: "error",
      }),
      refresh()
    );
  };

  const onSuccess = (data) => {
    redirect("show", "Trunc", data.id);
    return window
      .open(data.transactions[0]?.transaction?.url, "_blank")
      .focus();
  };

  return (
    <Toolbar
      {...props}
      sx={{ display: "flex", justifyContent: "space-between" }}
    >
      <SaveButton type="button" mutationOptions={{ onSuccess, onError }} />
    </Toolbar>
  );
};

const createTrunc = () => {
  const plugins = JSON.parse(localStorage.getItem("plugins"));

  return (
    <Create redirect="show">
      <SimpleForm toolbar={<SaveTruncToolbar />}>
        <ReferenceInput source="client_id" reference="Client">
          <AutocompleteInput
            sx={{
              width: "20%",
              "@media (max-width:900px)": {
                width: "100%",
              },
            }}
            inputText={(record) => record.phone}
            optionText="phone"
            optionValue="id"
            debounce={10}
            validate={[required()]}
            filterToQuery={(searchText) => ({ phone: searchText })}
          />
        </ReferenceInput>
        <ReferenceInput
          source="merchant_payment_gateway_id"
          reference="MerchantPaymentGateway"
          filter={{
            ...(plugins && !plugins.multiplePaymentGateways
              ? { default: true }
              : {}),
            status: MERCHANT_PAYMENT_GATEWAY_STATUSES.active.name,
          }}
        >
          <SelectInput
            sx={{
              width: "20%",
              "@media (max-width:900px)": {
                width: "100%",
              },
            }}
            optionText="name"
            optionValue="id"
            validate={[required()]}
          />
        </ReferenceInput>
        <SelectInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="webhook_service_name"
          choices={[
            {
              id: "topupDatex",
              name: "resources.Trunc.source.webhook_service_name.topupDatex",
            },
            // {
            //   id: "preSellCouponFromStock",
            //   name: "resources.Trunc.source.webhook_service_name.preSellCouponFromStock",
            // },
          ]}
          optionText="name"
          optionValue="id"
          validate={[required()]}
        />
        <TextInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          type="number"
          source="amount"
          validate={[intRegex, required(), minValue(1), maxValue(10000)]}
        />
        <TextInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="description"
          inputProps={{ maxLength: 64 }}
          validate={[required()]}
        />
      </SimpleForm>
    </Create>
  );
};

export default createTrunc;
